import React from 'react';
import { IonCardTitle, IonCardContent } from '@ionic/react';

type Props = {
  hours: [],
  title: string,
};

const OperatingHours: React.FC<Props> = ({ hours, title }) => {
  if (!hours) {
    return (
      <div>
        <IonCardContent>
          <IonCardTitle>{title}</IonCardTitle>
          <div>???</div>
        </IonCardContent>
      </div>
    );
  }
  return (
    <div>
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        { hours.map((item: any, index: number) => {
            const { exceptions } = item;
            let exceptionsCount = 0;
            if (exceptions) {
              exceptionsCount = exceptions.length;
            }
            return (
              <div key={'hours'+index}>
                <div>{item.name}</div>
                <div>{item.description}</div>
                <div>
                  <div><b>Hours:</b></div>
                  <ul>
                    <li>Monday: {item.standardHours.monday}</li>
                    <li>Tuesday: {item.standardHours.tuesday}</li>
                    <li>Wednesday: {item.standardHours.wednesday}</li>
                    <li>Thursday: {item.standardHours.thursday}</li>
                    <li>Friday: {item.standardHours.friday}</li>
                    <li>Saturday: {item.standardHours.saturday}</li>
                    <li>Sunday: {item.standardHours.monday}</li>
                  </ul>
                </div>
                <div className={exceptionsCount > 0 ? '' : 'hidden'}>
                  <b>Exceptions:</b>
                  {
                    exceptions.map((ex: any, index2: number) => {
                      const isSame = ex.endDate === ex.startDate;
                      // const hasExceptionHours = Object.keys(ex.exceptionHours).length;
                      return (
                        <div key={'exceptions' + index2}>
                          <div><u>{ex.name}</u></div>
                          <div className={isSame ? '' : 'hidden'}>Date: {ex.startDate}</div>
                          <div className={isSame ? 'hidden' : ''}>Date: {ex.startDate} - {ex.endDate}</div>
                        </div>
                      );
                    })
                  }
                </div>
                <hr />
              </div>
            );
          })
        }
        <div></div>
      </IonCardContent>
    </div>
  )
  
};

export default OperatingHours;